import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {Button, IconButton, List, ListItem, ListItemText, Stack, styled} from '@mui/material';
import {get} from 'lodash';
import {FC, useRef} from 'react';
import {useRecoilValue} from 'recoil';
import {AccordionHandle, FiltersAccordion} from '../../../../components/Filters';
import {FiltersSetDto} from '../../../../global/api';
import {GetFiltersSetsQuery, useGetFiltersSetsQuery} from '../../../../global/services/filters-sets';
import {ToastHelpers} from '../../../../shared/helpers/toastHelpers';
import {authState} from '../../../../store/auth/atoms';
import {entriesToFilters} from '../../helpers/entries-to-filters';
import {contractTableDeleteFilterModalOpen} from '../../stores/contract-table-filters-delete-modal.store';
import {contractTableFiltersEditModalOpen} from '../../stores/contract-table-filters-edit-modal.store';
import {setFilters} from '../../stores/contracts-table-filters.store';
import {ContractsTableAccordionContainer} from './contracts-table-accordion-container';

export const ContractsTableFiltersSets: FC = () => {
  const ref = useRef<AccordionHandle | null>(null);
  const {user} = useRecoilValue(authState);
  const params = {filterType: 'CONTRACTS', userUid: user?.uid} as GetFiltersSetsQuery;
  const {data} = useGetFiltersSetsQuery(params);
  const filters = get(data, 'content', []);

  const handleExpandFilter = () => {};

  const handleDeleteFilter = (filter: FiltersSetDto) => {
    if (!filter.id) return;
    contractTableDeleteFilterModalOpen(filter.id);
  };

  const handleSelectFilter = (filter: FiltersSetDto) => {
    try {
      setFilters(entriesToFilters(JSON.parse(filter.filters)));
      ref.current?.close();
    } catch (error) {
      ToastHelpers.error(error);
    }
  };

  const handleEditFilter = (filter: FiltersSetDto) => {
    contractTableFiltersEditModalOpen(filter);
  };

  return (
    <ContractsTableAccordionContainer>
      <FiltersAccordion ref={ref} onChange={handleExpandFilter} summaryContent="Наборы фильтров">
        <List disablePadding>
          {filters.map((filter) => (
            <StyledListItem key={filter.id} disablePadding>
              <StyledButton
                variant="text"
                onClick={() => handleSelectFilter(filter)}
                children={<ListItemText primary={filter.name} />}
              />
              <ButtonsContainer>
                <IconButton
                  size="small"
                  children={<EditIcon color="primary" />}
                  onClick={() => handleEditFilter(filter)}
                />
                <IconButton
                  size="small"
                  children={<DeleteIcon color="error" />}
                  onClick={() => handleDeleteFilter(filter)}
                />
              </ButtonsContainer>
            </StyledListItem>
          ))}
        </List>
      </FiltersAccordion>
    </ContractsTableAccordionContainer>
  );
};

const StyledListItem = styled(ListItem)({
  '&:hover': {backgroundColor: 'rgba(25, 118, 210, 0.04)'},
});

const StyledButton = styled(Button)({
  width: '100%',
  textTransform: 'none',
  color: 'inherit',
  textAlign: 'left',
  backgroundColor: 'transparent',
  '&:hover': {backgroundColor: 'transparent'},
});

const ButtonsContainer = styled(Stack)({
  flexDirection: 'row',
  gap: 1,
});
